import {create} from "zustand";

import type {GeolocationState} from "@/src/modules/core/types/geolocation";

const initialState: GeolocationState = {
  status: "idle",
  fix: null,
  error: null,
  isWatching: false,
};

export const useGeolocationStore = create<GeolocationState>(() => initialState);

export function getGeolocationState(): GeolocationState {
  return useGeolocationStore.getState();
}
